import type { DeviceType } from '@previo/design-system'
import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'

type SwitchBackBody = {
  deviceType: DeviceType
}

export class VersionSwitchAPI extends Http {
  switchBack = (deviceType: DeviceType): Promise<null> => {
    return this.callAuthWithPropertyAPI<SwitchBackBody, null>(
      HttpMethod.POST,
      { path: APIPaths.VERSION_SWITCH_BACK },
      { deviceType },
    )
  }
}

export const useVersionSwitchAPI = (): VersionSwitchAPI => {
  return new VersionSwitchAPI()
}
